import { createContext, useContext, useEffect, useState, useCallback } from "react";
import API from "../config/api.js";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [manager, setManager] = useState(null);
  const [userMetaFacebook, setUserMetaFacebook] = useState(null);
  const [userMetaInstagram, setUserMetaInstagram] = useState(null);
  const [userLinkedin, setUserLinkedin] = useState(null);
  const [userTiktok, setUserTiktok] = useState(null);
  const [userCategories, setUserCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const clearAuth = useCallback(() => {
    setUser(null);
    setSubscription(null);
    setAdmin(null);
    setManager(null);
    setUserMetaFacebook(null);
    setUserMetaInstagram(null);
    setUserLinkedin(null);
    setUserTiktok(null);
    setUserCategories([]);
  }, []);

  const refreshAuth = useCallback(async () => {
    try {
      setLoading(true);

      const res = await fetch(`${API.account}?me`, {
        credentials: "include",
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const data = await res.json();

      if (!data || Array.isArray(data)) {
        clearAuth();
        return;
      }

      setUser(data.user || null);
      setSubscription(data.subscription || null);
      setAdmin(data.admin || null);
      setManager(data.manager || null);
      setUserMetaFacebook(data.user_meta_facebook || null);
      setUserMetaInstagram(data.user_meta_instagram || null);
      setUserLinkedin(data.user_linkedin || null);
      setUserTiktok(data.user_tiktok || null);
      setUserCategories(Array.isArray(data.user_categories) ? data.user_categories : []);
    } catch (err) {
      console.error("Erro ao carregar sessão:", err);
      clearAuth();
    } finally {
      setLoading(false);
    }
  }, [clearAuth]);

  useEffect(() => {
    refreshAuth();
  }, [refreshAuth]);

  return (
    <AuthContext.Provider
      value={{
        user,
        subscription,
        admin,
        manager,
        userMetaFacebook,
        userMetaInstagram,
        userLinkedin,
        userTiktok,
        userCategories,
        loading,
        refreshAuth,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}